import React, { useState } from 'react';
import Modal from '../../../../../Components/Modal/Modal';
import { Size } from '../../../../../Enums/Size.enum';
import Text from '../../../../../Components/Base/Text/Text';
import { Theme } from '../../../../../Enums/Theme.enum';
import Button from '../../../../../Components/Button/Button';
// @ts-ignore
import styles from './OnlineOrdersInstructionsModal.module.scss';
import Checkbox from '../../../../../Components/Base/Checkbox/Checkbox';
import LocalStorage from '../../../../../Services/LocalStorage';
import { doNotShowHintAgain } from '../../../Services/manager.service';
import { useAppContext } from '../../../../../Services/AppContext';

interface Props {
	isOpened: boolean;
	onClose: () => void;
}

const OnlineOrdersInstructionsModal: React.FC<Props> = ({
	isOpened,
	onClose,
}) => {
	const { isLatam } = useAppContext();
	const [doNotShowAgain, setDoNotShowAgain] = useState(false);
	const handleContinue = () => {
		if (doNotShowAgain) {
			doNotShowHintAgain('doNoShowOnlineOrdersInstructionsModal');
		}
		onClose();
	};

	return (
		<Modal opened={isOpened} onClose={onClose} size={Size.SM}>
			<Modal.Header
				title='component.onlineOrdersInstructionsModal.title'
				firstUpper
			/>
			<Modal.Content contentScroll={true}>
				<div className={styles.wrapper}>
					<Text tx='component.onlineOrdersInstructionsModal.text1' />
					<Text
						tx='component.onlineOrdersInstructionsModal.text2'
						className={isLatam ? undefined : styles.textBold}
					/>
					<Checkbox
						value={doNotShowAgain}
						onChange={() => setDoNotShowAgain(!doNotShowAgain)}
						tx='component.serviceScheduleInstructionsModal.checkbox'
					/>
					<div className={styles.controls}>
						<Button
							theme={Theme.GREEN}
							title='component.onlineOrdersInstructionsModal.button'
							onClick={handleContinue}
						/>
					</div>
				</div>
			</Modal.Content>
		</Modal>
	);
};

export default OnlineOrdersInstructionsModal;
